import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { useId, type ReactNode } from 'react';
import { cx } from '../cx.js';

export interface CheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label: ReactNode;
  /** Testo secondario sotto l'etichetta. */
  hint?: ReactNode;
  disabled?: boolean;
  id?: string;
  className?: string;
}

/** Casella di controllo con area cliccabile di almeno 44px e etichetta associata. */
export function Checkbox({ checked, onCheckedChange, label, hint, disabled, id, className }: CheckboxProps) {
  const autoId = useId();
  const inputId = id ?? autoId;
  return (
    <div className={cx('flex items-start gap-3 min-h-[44px]', className)}>
      <RadixCheckbox.Root
        id={inputId}
        checked={checked}
        disabled={disabled}
        onCheckedChange={(v) => onCheckedChange(v === true)}
        className={cx(
          'mt-2.5 h-6 w-6 shrink-0 rounded-sm border border-border-strong bg-surface inline-flex items-center justify-center',
          'data-[state=checked]:bg-accent data-[state=checked]:border-accent data-[state=checked]:text-on-accent',
          'disabled:opacity-60 disabled:cursor-not-allowed',
        )}
      >
        <RadixCheckbox.Indicator>
          <Check aria-hidden size={16} strokeWidth={2.5} />
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      <label htmlFor={inputId} className={cx('flex flex-col gap-0.5 py-2.5 cursor-pointer', disabled && 'cursor-not-allowed')}>
        <span className="t-body text-ink">{label}</span>
        {hint && <span className="t-body-small text-ink-muted">{hint}</span>}
      </label>
    </div>
  );
}
